import React, { useState, useRef, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import Odometer from 'react-odometerjs';

import fortyFivePlus from '../../../assets/images/fortyFivePlus.png';
import inotechAdvisory from '../../../assets/images/inotechAdvisory.png';
import fourThousandMembers1 from '../../../assets/images/fourThousandMembers1.png';
import commercialLines from '../../../assets/images/commercialLines.png';
import commercialLinesData from '../../../assets/images/commercialLinesData.png';

const Highlights = ({ isMobile }) => {
  return (
    <Col>
      <Row>
        <Col>
          <h2
            id="2020-highlights"
            tabIndex="-1"
          >
            2020 high{isMobile && "-"}{isMobile && <br />}lights
          </h2>
        </Col>
      </Row>
      <Row style={{ marginTop: 30 }}>
        <Col>
          <p>
            CSIO accomplishments arise from the commitment to excellence and dedication of our valued partners. Insurers, brokers and vendors share their breadth of experience to benefit the whole industry by demonstrating their devotion to collaboration, digital innovation and continuous improvement.
        </p>
        </Col>
      </Row>
      <Row>
        <Col
          xs={12} sm={6} md={4} lg={4} xl={3}
          style={{ paddingLeft: 25, paddingRight: 25, marginTop: 20 }}
        >
          <Row style={{ height: '100%' }}>
            <FourHundredPercentIncrease />
          </Row>
        </Col>
        <Col
          xs={12} sm={6} md={4} lg={4} xl={3}
          style={{ paddingLeft: 25, paddingRight: 25, marginTop: 20 }}
        >          <Row style={{ height: '100%' }}>
            <FortyFiveMillion />
          </Row>
        </Col>
        <Col
          xs={12} sm={6} md={4} lg={4} xl={3}
          style={{ paddingLeft: 25, paddingRight: 25, marginTop: 20 }}
        >          <Row style={{ height: '100%' }}>
            <ELearning />
          </Row>
        </Col>
        <Col
          xs={12} sm={6} md={4} lg={4} xl={3}
          style={{ paddingLeft: 25, paddingRight: 25, marginTop: 20 }}
        >          <Row style={{ height: '100%' }}>
            <FourThousandMembers />
          </Row>
        </Col>

      <Col
          xs={12} sm={12} md={8} lg={8} xl={6}
          style={{ paddingLeft: 25, paddingRight: 25, marginTop: 20 }}
        >          <Row style={{ height: '100%' }}>
            <InnotechAdvisory />
          </Row>
        </Col>
        <Col
          xs={12} sm={6} md={6} lg={6} xl={3}
          style={{ paddingLeft: 25, paddingRight: 25, marginTop: 20 }}
        >          <Row style={{ height: '100%' }}>
            <CommercialLines />
          </Row>
        </Col>
        <Col
          xs={12} sm={6} md={6} lg={6} xl={3}
          style={{ paddingLeft: 25, paddingRight: 25, marginTop: 20 }}
        >          <Row style={{ height: '100%' }}>
            <CommercialLinesData />
          </Row>
        </Col>
      </Row>

      {/* <Row>
        <Col>
          <Row style={{
            marginBottom: 20
          }}>
            <Col xs={6} style={{ paddingLeft: 25, paddingRight: 25 }}>

            </Col>
            <Col xs={6} style={{ paddingLeft: 25, paddingRight: 25 }}>
              <Row style={{ height: '100%' }}>
                <FortyFiveMillion />
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={12} style={{ paddingLeft: 25, paddingRight: 25 }}>
              <Row>
                <InnotechAdvisory />
              </Row>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row style={{
            marginBottom: 20
          }}>
            <Col xs={6} style={{ paddingLeft: 25, paddingRight: 25 }}>
              <Row>
                <ELearning />
              </Row>
            </Col>
            <Col xs={6} style={{ paddingLeft: 25, paddingRight: 25 }}>
              <Row style={{ height: '100%' }}>
                <FourThousandMembers />
              </Row>
            </Col>
          </Row>
          <Row style={{
            marginBottom: 20
          }}>
            <Col xs={6} style={{ paddingLeft: 25, paddingRight: 25 }}>
              <Row>
                <CommercialLines />
              </Row>
            </Col>
            <Col xs={6} style={{ paddingLeft: 25, paddingRight: 25 }}>
              <Row style={{ height: '100%' }}>
                <CommercialLinesData />
              </Row>
            </Col>
          </Row>


        </Col>
      </Row> */}

    </Col>
  )
}

export default Highlights;

const FourHundredPercentIncrease = () => (
  <Col style={{ backgroundColor: '#F3F5ED', height: '100%', padding: 20 }}>
    <Row>
      <Odom number={400} text="%" odomStyle={{
        fontSize: 48,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1B526D',
        lineHeight: 1,
        padding: 0,
      }} />
    </Row>
    <Row>
      <Col style={{
        fontSize: 25,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1B526D',
        textAlign: 'center',
        lineHeight: 1,
        padding: 0,
        paddingBottom: 6
      }}>
        INCREASE
        </Col>
    </Row>
    <Row>
      <Col style={{
        fontSize: 18,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#8A9D76',
        textAlign: 'center'
      }}>
        IN eSLIPS AND POLICY DOCUMENTS SENT <span style={{ color: '#48604C' }}>DIGITALLY</span> THROUGH <span style={{ color: '#48604C' }}>MPOI</span>
      </Col>
    </Row>
  </Col>
)

const FortyFiveMillion = () => (
  <Col style={{ backgroundColor: '#F3F5ED', height: '100%', padding: 20 }}>
    <Row style={{ height: '100%' }}>
      <Col xs={3}>
        <img
          src={fortyFivePlus}
          style={{
            width: '100%',
            height: 'auto'
          }}
          alt=""
        />
      </Col>
      <Col xs={9} style={{
        paddingLeft: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }}>
        <Row>
          <Odom number={45} text="+" odomStyle={{
            fontSize: 48,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#1C1F3D',
            lineHeight: 1,
            padding: 0,
          }} />
        </Row>
        <Row>
          <Col style={{
            fontSize: 28,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#1C1F3D',
            textAlign: 'center',
            lineHeight: 1,
            padding: 0,
            paddingBottom: 6
          }}>
            MILLION
        </Col>
        </Row>
        <Row>
          <Col style={{
            fontSize: 25,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#48604C',
            textAlign: 'center'
          }}>
            eDocs sent
      </Col>
        </Row>
      </Col>
    </Row>
  </Col>
)

const InnotechAdvisory = () => (
  <Col style={{ backgroundColor: '#F3F5ED', height: '100%', padding: 20 }}>
    <Row>
      <Col xs={5} style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }}>
        <Row>
          <Col style={{
            fontSize: 16,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#1B526D',
            textAlign: 'left',
            lineHeight: 1.5,
            // padding: 0,
            paddingBottom: 6
          }}>
            INNOTECH ADVISORY<br />COMMITTEE FINALIZED
        </Col>
        </Row>
        <Row>
          <Col style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#1C1F3D',
            textAlign: 'left'
          }}>
            3 DIGITAL SOLUTIONS
      </Col>
        </Row>
        <Row>
          <Col style={{
            fontSize: 16,
            fontFamily: 'montserrat medium',
            fontWeight: 'bold',
            color: '#1C1F3D',
            lineHeight: 1.5,
            textAlign: 'left'
          }}>
            TO IMPROVE THE<br />CUSTOMER EXPERIENCE
      </Col>
        </Row>
      </Col>
      <Col xs={7} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <img
          src={inotechAdvisory}
          style={{
            width: '100%',
            height: 'auto',
            paddingLeft: 20,
            paddingRight: 20
          }}
          aria-label="Circle with three lines of text: Billing notification, api industry standardization, claims digital notification"
        />
      </Col>
    </Row>

  </Col>
)

const ELearning = () => (
  <Col style={{ backgroundColor: '#F3F5ED', height: '100%', padding: 20, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
    <Row>
      <Col style={{
        fontSize: 36,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1C1F3D',
        textAlign: 'center',
        lineHeight: 1,
        padding: 0,
        paddingBottom: 6
      }}>
        eLEARNING:
        </Col>
    </Row>
    <Row>
      <Col style={{
        fontSize: 18,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#48604C',
        textAlign: 'center'
      }}>
        DIGITAL MEMBER CERTIFICATION PROGRAM
      </Col>
    </Row>
    <Row>
      <Col style={{
        fontSize: 25,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1B526D',
        textAlign: 'center',
        lineHeight: 1.5,
        padding: 0,
        paddingBottom: 6
      }}>
        LAUNCHED
        </Col>
    </Row>
  </Col>
)

const FourThousandMembers = () => (
  <Col style={{ backgroundColor: '#F3F5ED', height: '100%', padding: 20 }}>
    <Row style={{ height: '100%' }}>
      <Col xs={4} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <img
          src={fourThousandMembers1}
          style={{
            width: '100%',
            height: 'auto'
          }}
          alt=""
        />
      </Col>
      <Col xs={8} style={{
        paddingLeft: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '100%',

      }}>
        <Row>
          <Odom format="(,ddd)" number={4000} text="" odomStyle={{
            fontSize: 54,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#EECA41',
            lineHeight: 1,
            padding: 0,
          }} />
        </Row>
        <Row>
          <Col style={{
            fontSize: 18,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#8A9D76',
            textAlign: 'center'
          }}>
            MEMBERS TOOK
          </Col>
        </Row>
        <Row>
          <Col style={{
            fontSize: 12,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#8A9D76',
            textAlign: 'center'
          }}>
            PART IN <span style={{ color: '#48604C', fontSize: 16, }}>eLEARNING</span>
          </Col>
        </Row>
      </Col>
    </Row>
  </Col>
)

const CommercialLines = () => (
  <Col style={{ backgroundColor: '#F3F5ED', height: '100%', padding: 20 }}>
    <Row style={{ height: '100%' }}>
      <Col xs={3} style={{ paddingRight: 0 }}>
        <img
          src={commercialLines}
          style={{
            width: '100%',
            height: 'auto'
          }}
          alt=""
        />
      </Col>
      <Col xs={9} style={{
        fontSize: 16,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1B526D',
        textAlign: 'center',
        lineHeight: 1.5,
        // padding: 0,
        paddingBottom: 6
      }}>
        COMMERCIAL LINES DATA STANDARDS CERTIFICATION PROGRAM
        <div style={{
          fontSize: 18,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#8A9D76',
          textAlign: 'center'
        }}>
          LAUNCHED
        </div>
      </Col>
    </Row>
  </Col>
)

const CommercialLinesData = () => (
  <Col style={{ backgroundColor: '#F3F5ED', height: '100%', padding: 20 }}>
    <Row>
      <Col style={{
        fontSize: 16,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#48604C',
        textAlign: 'left'
      }}>
        COMMERCIAL LINES DATA STANDARDS COMPLETED FOR
      </Col>
    </Row>
    <Row>
      <Col style={{
        fontSize: 18,
        fontFamily: 'montserrat medium',
        // fontWeight: 'bold',
        color: '#48604C',
        textAlign: 'left'
      }}>
        2 SEGMENTS:
      </Col>
    </Row>
    <Row style={{ marginTop: 8 }}>
      <Col xs={3}>
        <img
          src={commercialLinesData}
          style={{
            width: '100%',
            height: 'auto'
          }}
          alt=""
        />
      </Col>
      <Col xs={9}>
        <ul style={{ marginLeft: 0, paddingLeft: 0 }}>
          <li style={{
            fontSize: 13,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#1C1F3D',
            textAlign: 'left'
          }}>
            RETAIL
            </li>
          <li style={{
            fontSize: 13,
            fontFamily: 'montserrat bold',
            fontWeight: 'bold',
            color: '#1C1F3D',
            textAlign: 'left'
          }}>
            BUSINESS AND PROFESSIONAL SERVICES
            </li>
        </ul>
      </Col>
    </Row>
  </Col>
)

export const Odom = ({ number, text, odomStyle, textStyle, style, preText, preTextStyle, format, xs }) => {
  const [odoVal, setOdoVal] = useState(0);
  const odomRef = useRef(null);

  useEffect(() => {
    const triggerAnimation = () => {
      if (odoVal === 0 && odomRef && odomRef.current && odomRef.current.getBoundingClientRect().top < window.innerHeight) {
        setOdoVal(number);
      };
    }
    window.addEventListener('scroll', triggerAnimation);
    triggerAnimation();
    return () => window.removeEventListener('scroll', triggerAnimation);
  }, [number, odoVal]);

  return (
    <Col xs={xs}>
      <Row ref={odomRef} style={{
        display: 'flex',
        justifyContent: 'center',
        ...style
      }}>
        {preText && <p style={preTextStyle || odomStyle}>
          {preText}
        </p>}
        <div
          style={odomStyle}>
          <Odometer
            format={format || "d"}
            duration={500}
            value={odoVal}
          // options={{
          //   el: ''
          // }}
          />
        </div>
        {text && <p style={textStyle || odomStyle}>
          {text}
        </p>}
      </Row>
    </Col>
  );
}